export default __webpack_public_path__ + "static/media/integrity.7cbe7c1b.jpg";